module.exports = __webpack_public_path__ + "img/wine-tasting.7c412981.svg";